<script>
  import { get } from 'svelte/store';
  import {
    idTrappe,
    nomTrappe,
    choix,
    dimLongueur,
    dimLargeur,
    sensOuverture,
    fermeture,
    type,
    couleur,
    epaisseur,
    dureeResistance,
    dimLongueurIdFiche,
    dimLargeurIdFiche,
    sensOuvertureIdFiche,
    fermetureIdFiche,
    typeIdFiche,
    couleurIdFiche,
    epaisseurIdFiche,
    dureeResistanceIdFiche,
    coupeFeuIdPath,
    trappePath,
  } from '../stores.js';

  import { asnavigate } from '../Utils/asnavigation.js';
  import { fly, blur } from 'svelte/transition';
  import LineSideBar from './LineSideBar.svelte';
  import { useNavigate } from 'svelte-navigator';

  export let idFiche;
  const navigate = useNavigate();

  // let goBack = '/';
  let goBack = '-1';
  // export let idParam;
  $: {
  }

  function asgoBack(navigate, goBack) {
    // navigate(-1);
    asnavigate(navigate, -1);
    // console.log(`asgoBack`);
  }

  // console.log(`type : ${type}`);
  // console.log(`fermeture : ${fermeture}`);
</script>

<!-- idFiche : {idFiche} <br />
IdTrappe : {$idTrappe} <br />
Path : {$trappePath} <br />
Choix : {$choix} <br />
CoupeFeuIdPath : {$coupeFeuIdPath} -->

<div class="as-btn-back" on:click="{() => asgoBack(navigate, goBack)}">
  <!-- <div class="as-btn-back" on:click="{() => navigate(-1)}"> -->
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
    ><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path
      d="M109.3 288L480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288z"
    ></path></svg
  >
</div>

<div class="relative sm:max-w-xl sm:mx-auto asdesk">
  <div
    style="backdrop-filter: blur(20px);"
    class="as-left-col text-white px-4 py-0 bg-black"
  >
    <div class="max-w-md mx-auto">
      <div class="py-8 text-base leading-6  sm:text-lg sm:leading-7">
        <div class="as-titre">VOS CHOIX</div>
        <p class="as-text-base">
          Choisissez les différentes options de votre trappe
        </p>
        <div class="text-left mt-12"></div>
        {#if idFiche}
          <div
            class="as-line-border"
            in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
          >
            <LineSideBar
              linecolor="#fff"
              idPage="LayoutPage"
              titre="{'Choix de la trappe <strong>' + $nomTrappe + '</strong>'}"
            />
          </div>
        {/if}
        {#if $type}
          <div
            class="as-line-border"
            in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
          >
            <LineSideBar
              linecolor="#fff"
              idPage="{'/LayoutPage/' + $typeIdFiche}"
              titre="{'Type d’installation : ' + $type + ' '}"
            />
          </div>
        {/if}
        {#if $dureeResistance}
          <div
            class="as-line-border"
            in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
          >
            <LineSideBar
              linecolor="#fff"
              idPage="{'/LayoutPage/' + $dureeResistanceIdFiche}"
              titre="{'Durée : ' + $dureeResistance + ' '}"
            />
          </div>
        {/if}
        {#if $epaisseur}
          <div
            class="as-line-border"
            in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
          >
            <LineSideBar
              linecolor="#fff"
              idPage="{'/LayoutPage/' + $epaisseurIdFiche}"
              titre="{'Epaisseur : ' + $epaisseur + ' '}"
            />
          </div>
        {/if}

        {#if $dimLongueur}
          <div
            class="as-line-border"
            in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
          >
            <LineSideBar
              linecolor="#fff"
              idPage="{'/LayoutPage/' + $dimLongueurIdFiche}"
              titre="{'Longueur de la trappe : ' + $dimLongueur + ' mm'}"
            />
          </div>
          <div
            class="as-line-border"
            in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
          >
            <LineSideBar
              linecolor="#fff"
              idPage="{'/LayoutPage/' + $dimLongueurIdFiche}"
              titre="{'Largeur de la trappe : ' + $dimLargeur + ' mm'}"
            />
          </div>
        {/if}
        {#if $sensOuverture}
          <div
            class="as-line-border"
            in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
          >
            <LineSideBar
              linecolor="#fff"
              idPage="{'/LayoutPage/' + $sensOuvertureIdFiche}"
              titre="{'Côté d’ouverture : ' + $sensOuverture}"
            />
          </div>
        {/if}
        {#if $fermeture}
          <div
            class="as-line-border"
            in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
          >
            <LineSideBar
              linecolor="#fff"
              idPage="{'/LayoutPage/' + $fermetureIdFiche}"
              titre="{'Fermeture : ' + $fermeture}"
            />
          </div>
        {/if}
      </div>
    </div>
  </div>
</div>

<style>
  .as-left-col {
    min-height: 700px;
  }
  .as-btn-back {
    cursor: pointer;
    display: inline-block;
    color: #fff;
    font-size: 50px;
    padding: 0px 5px;
    margin-bottom: 10px;
    background-color: #000;
  }
  .as-btn-back svg {
    width: 70px;
    height: 50px;
  }
  .as-btn-back svg path {
    fill: #fff;
  }
  .as-titre {
    color: #fff;
    position: relative;
    font-family: 'introblack';
    font-size: 35px;
    line-height: 30px;
  }
  .as-titre::after {
    content: '';
    position: absolute;
    inset: auto auto -15px 0;
    border: 4px solid #fff;
    width: 40px;
  }
  .as-text-base {
    font-size: 17px;
    line-height: 23px;
    margin-top: 35px;
  }
  @media only screen and (max-width: 768px) {
    .as-btn-back {
      padding: 0 10px;
    }
    .as-btn-back svg {
      width: 40px;
      height: auto;
    }
  }
</style>
